import { action, computed, observable } from 'mobx'
import { required, validationContext } from 'validx'
import {
  mustBeValidTaxFormInputValue,
  mustHaveMaxLength,
  validateObject,
} from '@/utils/validx-util'
import { ContactInfoEditorViewModel } from '@/features/jobs/info-gathering/ContactInfoEditorViewModel'
import { PersonalInfoEditorViewModel } from './PersonalInfoEditorViewModel'
import type { PersonalProfileVersion } from './PersonalProfileVersion'

/**
 * Editor for a personal profile.
 */
export class PersonalProfileEditorViewModel {
  readonly personalInfoVm = new PersonalInfoEditorViewModel()
  readonly contactInfoVm = new ContactInfoEditorViewModel()

  @observable private accessor _occupation = ''

  readonly validation = validationContext(this, {
    personalInfoVm: [validateObject()],
    contactInfoVm: [validateObject()],
    occupation: [
      required('Occupation is required'),
      mustBeValidTaxFormInputValue(),
      mustHaveMaxLength(100, 'Occupation must not exceed 100 characters'),
    ],
  })

  @computed get occupation() {
    return this._occupation
  }

  set occupation(value: string) {
    this._occupation = value
    this.validation.clearErrors('occupation')
  }

  /**
   * Resets the editor to the given profile, or to defaults.
   */
  @action.bound
  reset(profile?: PersonalProfileVersion | null) {
    this.personalInfoVm.reset(profile?.personalInfo)
    this.contactInfoVm.reset(profile?.contactInfo)
    this.occupation = profile?.occupation ?? ''
    this.validation.reset()
  }
}
